import { GoATable, GoAFormItem, GoAButton, GoAInputText } from '@abgov/react-components';
import * as React from 'react';
import PageLoader from '../../components/PageLoader';
import { IFlightReport } from '../../model/IFlightReport';
import { USLog } from '../../model/Unserviceable/IUSLog';
import { updateHourWithColon, validateHoursMinutes } from '../../utils/checkInput';
import Select from 'react-select';
import moment from 'moment';
import { useAuth } from 'react-oidc-context';

interface IEditUSLogProps {
  flightReport: IFlightReport;
  arrUSLogs: USLog[];
  onChange: (value: Array<USLog>) => void;
  // onDelete: (value: Array<USLog>, deletedValuesArray: Array<USLog>) => void;
}
export function setUsLogsErrors(value: Array<USLog>): boolean {
  let hasError = false;
  value.forEach((log) => {
    if (log.startTime) {
      if (!validateHoursMinutes(log.startTime, 2)) {
        hasError = true;
      }
    } else {
      hasError = true;
    }

    if (log.endTime) {
      if (!validateHoursMinutes(log.endTime, 2)) {
        hasError = true;
      }
    } else {
      hasError = true;
    }

    if (log.reason === undefined || log.reason === '') {
      log.reasonError = 'Required to save';
      hasError = true;
    } else {
      log.reasonError = '';
    }
  });
  return hasError;
}
const EditUSLog: React.FunctionComponent<IEditUSLogProps> = ({
  flightReport,
  arrUSLogs,
  onChange,
  // onDelete,
  ...props
}) => {
  const auth = useAuth();
  //Loader
  const [loading, setIsLoading] = React.useState(false);
  const [rowsUSLogs, setRowsUSLogs] = React.useState<USLog[]>([]);

  // eslint-disable-next-line
  const [tempRowsUSLogs, setTempRowsUSLogs] = React.useState<USLog[]>([]);

  const reasonOptions = [
    { label: 'Mechanical', value: 'Mechanical' },
    { label: 'Personnel', value: 'Personnel' },
    { label: 'Other', value: 'Other' },
  ];

  React.useEffect(() => {
    setIsLoading(true);

    if (arrUSLogs) {
      setRowsUSLogs((p) => {
        return [...arrUSLogs];
      });
      setTempRowsUSLogs((p) => {
        return [...arrUSLogs];
      });
    }

    setIsLoading(false);
  }, [arrUSLogs]);

  //on property values change
  function onPropertyChange(idx: number, value: Partial<USLog>) {
    let newValue = new USLog(rowsUSLogs[idx]);

    if (newValue.uSLogId !== '00000000-0000-0000-0000-000000000000') {
      newValue.updateTimestamp = moment(new Date()).format('yyyy-MM-DD');
      newValue.updateUserId = auth?.user?.profile?.name ?? 'wildfire';
    }

    newValue = new USLog({ ...newValue, ...value });
    let rows = [...rowsUSLogs];
    rows[idx] = newValue;
    setRowsUSLogs((p) => {
      return rows;
    });

    //send on change to parent component "FlightReportSummary"
    onChange(rows);
  }

  async function handleAddRow() {
    setIsLoading(true);

    const uSLog = new USLog();
    uSLog.flightReportId = flightReport.flightReportId;
    uSLog.createTimestamp = moment(new Date()).format('yyyy-MM-DD');
    uSLog.createUserId = auth?.user?.profile?.name ?? 'wildfire';

    const updatedRows = [...rowsUSLogs, uSLog];
    setRowsUSLogs(updatedRows);

    //onAddNewRow(false);
    onChange(updatedRows);
    setIsLoading(false);
  }

  // async function handleDelete(id: string, idx: number) {
  //     // Create a copy of formValues
  //     const updatedRowsUSLogs = [...rowsUSLogs];
  //     let filterRowsUSLogs = [...rowsUSLogs];

  //     var tobeDeletedIndex;
  //     // Find the item to be deleted
  //     if (id !== undefined && id !== "00000000-0000-0000-0000-000000000000") {
  //         tobeDeletedIndex = updatedRowsUSLogs.findIndex(
  //             (x) => x.uSLogId === id,
  //         );
  //     } else tobeDeletedIndex = idx;

  //     if (tobeDeletedIndex !== -1) {
  //         // Create a copy of the item to be deleted
  //         const tobeDeleted = {...updatedRowsUSLogs[tobeDeletedIndex]};

  //         // Update the 'deleted' property
  //         tobeDeleted.deleted = true;

  //         if (
  //             tobeDeleted.startTime === "" &&
  //             tobeDeleted.endTime === "" &&
  //             tobeDeleted.reason === ""
  //         ) {
  //             updatedRowsUSLogs.splice(tobeDeletedIndex, 1);
  //             filterRowsUSLogs.splice(tobeDeletedIndex, 1);
  //         } else {
  //             // Replace the item in the updatedRowsUSLogs array
  //             updatedRowsUSLogs[tobeDeletedIndex] = tobeDeleted;
  //             filterRowsUSLogs[tobeDeletedIndex] = tobeDeleted;

  //             filterRowsUSLogs = filterRowsUSLogs.filter((x) => !x.deleted);
  //         }

  //         // Update the state and trigger a re-render
  //         setRowsUSLogs(filterRowsUSLogs);
  //         //setRowsUSLogs(updatedRowsUSLogs);

  //         //send on change to parent component "FlightReportSummary"
  //         onDelete(updatedRowsUSLogs, filterRowsUSLogs);
  //     }
  // }
  async function handleDelete(id: string, idx: number) {
    const isPersisted = id && id !== '00000000-0000-0000-0000-000000000000';

    const index = isPersisted ? rowsUSLogs.findIndex((x) => x.uSLogId === id) : idx;

    if (index === -1) return;

    const target = rowsUSLogs[index];

    const isEmpty = !target.startTime && !target.endTime && !target.reason;

    let updatedRows: USLog[];

    if (isEmpty) {
      // Physically remove
      updatedRows = rowsUSLogs.filter((_, i) => i !== index);
    } else {
      // Soft delete
      updatedRows = rowsUSLogs.map((row, i) => (i === index ? { ...row, deleted: true } : row));
    }

    // const visibleRows = updatedRows.filter((x) => !x.deleted);

    // setRowsUSLogs(visibleRows);
    onChange(updatedRows);
    // onDelete(updatedRows, visibleRows);
  }
  return (
    <>
      <PageLoader visible={loading} />

      <div className='row section-margin-top-20'>
        <div className='width100'>
          <div className='column width100'>
            <div className='row accordion unserviceableReport'>
              <div>
                <div>
                  <h3 className='insideHeader expense-section-header'>Unserviceable Log</h3>
                </div>
                <div className='content'>
                  <div className='unserviceable white-background'>
                    <GoATable width='100%'>
                      <thead>
                        <tr>
                          <th className='width185px'>Start Time</th>
                          <th className='width215px'>End Time</th>
                          <th className='width240px'>Reason</th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody
                        style={{
                          position: 'sticky',
                          top: 0,
                        }}
                      >
                        {rowsUSLogs || rowsUSLogs !== undefined ? (
                          rowsUSLogs
                            // .filter((x) => !x.deleted)
                            .map((_record: any, idx: any) => {
                              if (_record.deleted) return null;
                              return (
                                <tr key={idx}>
                                  <td>
                                    <GoAFormItem error={_record?.startTimeError}>
                                      <GoAInputText
                                        name={'txtStartTime' + idx}
                                        value={_record?.startTime}
                                        width='100%'
                                        maxLength={5}
                                        placeholder='hh:mm'
                                        error={_record?.isStartTimeError}
                                        onChange={(name, value) => {
                                          if (value) {
                                            if (validateHoursMinutes(value, 2)) {
                                              onPropertyChange(idx, {
                                                startTime: value,
                                                isStartTimeError: false,
                                                startTimeError: '',
                                                isEndTimeError: false,
                                                endTimeError: '',
                                              });
                                            } else {
                                              const updatedValue = updateHourWithColon(value);
                                              onPropertyChange(idx, {
                                                startTime: updatedValue,
                                                isStartTimeError: true,
                                                startTimeError: 'hh:mm valid format',
                                              });
                                            }
                                          } else {
                                            onPropertyChange(idx, {
                                              startTime: null,
                                              isStartTimeError: false,
                                              startTimeError: '',
                                            });
                                          }
                                        }}
                                      />
                                    </GoAFormItem>
                                  </td>
                                  <td>
                                    <GoAFormItem error={_record?.endTimeError}>
                                      <GoAInputText
                                        name={'txtEndTime' + idx}
                                        value={_record?.endTime}
                                        width='100%'
                                        maxLength={5}
                                        placeholder='hh:mm'
                                        error={_record?.isEndTimeError}
                                        onChange={(name, value) => {
                                          if (value) {
                                            if (validateHoursMinutes(value, 2)) {
                                              onPropertyChange(idx, {
                                                endTime: value,
                                                isEndTimeError: false,
                                                endTimeError: '',
                                                isStartTimeError: false,
                                                startTimeError: '',
                                              });
                                            } else {
                                              const updatedValue = updateHourWithColon(value);
                                              onPropertyChange(idx, {
                                                endTime: updatedValue,
                                                isEndTimeError: true,
                                                endTimeError: 'hh:mm valid format',
                                              });
                                            }
                                          } else {
                                            onPropertyChange(idx, {
                                              endTime: null,
                                              isEndTimeError: false,
                                              endTimeError: '',
                                            });
                                          }
                                        }}
                                      />
                                    </GoAFormItem>
                                  </td>
                                  <td>
                                    <Select
                                      name={'selReason' + idx}
                                      options={reasonOptions}
                                      className='width100'
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                      value={reasonOptions.find((t) => t.value === _record.reason)}
                                      onChange={async (value: any) => {
                                        if (value.value) {
                                          onPropertyChange(idx, {
                                            reason: value.value,
                                          });
                                        }
                                      }}
                                      isSearchable={true}
                                    />
                                  </td>
                                  <td>
                                    <GoAButton type='tertiary' leadingIcon='trash' onClick={() => handleDelete(_record.uSLogId, idx)}></GoAButton>
                                  </td>
                                </tr>
                              );
                            })
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </GoATable>
                  </div>

                  <div className='unserviceable flying-hours'>
                    <GoAButton type='secondary' trailingIcon='add' onClick={() => handleAddRow()}>
                      Add new
                    </GoAButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUSLog;
